import React from "react";
import classNames from "classnames";
import { registerLocale } from 'react-datepicker';

import es from 'date-fns/locale/es';
import {
    InputGroup,
    DatePicker,
    InputGroupAddon,
    InputGroupText,
    Row,
    Col
} from "shards-react";



import "../../assets/range-date-picker.css";

registerLocale('es-ES', es);
class RangeDatePicker extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            startDate: props.startDate || "",
            endDate: props.endDate || ""
        };

        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
    }

    handleStartDateChange(value) {
        this.setState({
            ...this.state,
            ...{ startDate: new Date(value) }
        });

        this.props.handleDate({
            date_start_value: new Date(value)
        })
    }

    componentWillUpdate(nextProps, nextState) {

        if (!nextProps.endDate && this.state.endDate) {
            this.setState({
                endDate: "",
            })
        }

        if (!nextProps.startDate && this.state.startDate) {
            this.setState({
                startDate: "",
            })
        }

    }

    handleEndDateChange(value) {
        this.setState({
            ...this.state,
            ...{ endDate: new Date(value) }
        });

        this.props.handleDate({
            date_end_value: new Date(value)
        })
    }

    render() {
        const { className, showLabels } = this.props;
        const classes = classNames(className, "d-flex", "my-auto", "date-range");

        return (
            <>
                {!showLabels &&
                    <InputGroup className={classes}>
                        <DatePicker
                            size="sm"
                            selected={this.state.startDate}
                            onChange={this.handleStartDateChange}
                            placeholderText="Desde"
                            dropdownMode="select"
                            className="text-center"
                            dateFormat='dd/MM/yyyy'
                            locale="es-ES"
                        />
                        <DatePicker
                            size="sm"
                            selected={this.state.endDate}
                            onChange={this.handleEndDateChange}
                            placeholderText="Hasta"
                            dropdownMode="select"
                            className="text-center"
                            dateFormat='dd/MM/yyyy'
                            locale="es-ES"
                        />
                        <InputGroupAddon type="append">
                            <InputGroupText>
                                <i className="material-icons">&#xE916;</i>
                            </InputGroupText>
                        </InputGroupAddon>
                    </InputGroup>
                }

                {showLabels &&
                    <InputGroup className={classes}>
                        <Col>
                            <label>Desde: </label>
                            <Row>
                                <DatePicker
                                    size="sm"
                                    selected={this.state.startDate}
                                    onChange={this.handleStartDateChange}
                                    placeholderText="Desde"
                                    dropdownMode="select"
                                    className="text-center"
                                    dateFormat='dd/MM/yyyy'
                                    locale="es-ES"
                                />
                            </Row>
                        </Col>
                        <Col>
                            <label>Hasta: </label>
                            <Row>
                                <DatePicker
                                    size="sm"
                                    selected={this.state.endDate}
                                    onChange={this.handleEndDateChange}
                                    placeholderText="Hasta"
                                    dropdownMode="select"
                                    className="text-center"
                                    dateFormat='dd/MM/yyyy'
                                    locale="es-ES"
                                />
                            </Row>
                        </Col>
                        <InputGroupAddon type="append" style={{ marginTop: '1.7rem' }} >
                            <InputGroupText>
                                <i className="material-icons">&#xE916;</i>
                            </InputGroupText>
                        </InputGroupAddon>
                    </InputGroup>
                }
            </>

        );
    }
}

export default RangeDatePicker;
